export default __webpack_public_path__ + "static/media/elixir-chat.ea3cbd53.gif";